import { useEffect, useState } from 'react';

export type ScrollDirection = 'up' | 'down' | undefined;

export const useScrollDirection = () => {
  const [scrollDirection, setScrolldirection] = useState<ScrollDirection>();

  useEffect(() => {
    let prevScrollPosition =
      window.pageYOffset || document.documentElement.scrollTop;
    let prevScrollDirection: ScrollDirection = undefined;

    function handleScroll() {
      const scrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;
      if (scrollPosition > prevScrollPosition && prevScrollDirection !== 'down') {
        prevScrollDirection = 'down';
        setScrolldirection('down');
      } else if (scrollPosition < prevScrollPosition && prevScrollDirection !== 'up') {
        prevScrollDirection = 'up';
        setScrolldirection('up');
      }
      prevScrollPosition = scrollPosition <= 0 ? 0 : scrollPosition;
    }

    window.addEventListener('scroll', handleScroll, false);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return scrollDirection;
};
